module.exports = __webpack_public_path__ + "img/117.8eacd8d.svg";